export const DOWNLOAD_TICKETS_ACTION = 'DOWNLOAD_TICKETS_ACTION'

export const downloadTicketsAction = (eventId: string) => ({
  type: DOWNLOAD_TICKETS_ACTION,
  payload: {
    eventId,
  },
})
